import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper'; 
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import moment from 'moment';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import psdfimage from './images/psdfimage.png';
import FormControl from '@mui/material/FormControl'; 
import InputLabel from '@mui/material/InputLabel';   
import Select from '@mui/material/Select';          
import MenuItem from '@mui/material/MenuItem';         
import Checkbox from '@mui/material/Checkbox';         
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle';   














function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}


function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export default class Trialbalancereport extends Component {
    constructor(props) {
        super(props);

      var strdob = new Date();
        var month = "";

        if ((strdob.getMonth() + 1) < 10) {
            month = "0" + (strdob.getMonth() + 1);
        } else {
            month = (strdob.getMonth() + 1);
        }

        const currentDate = new Date();

        var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
        var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();

        this.state = {
            redirect: false,
            ReportData: [],
            
            orderBy: '',
            order: 'asc',
			
			todate1:   currentDate.getFullYear()+ '-' +month1 + '-' + lastDay, todate: lastDayOfMonth,
            fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1), 
            fromdate1:  currentDate.getFullYear()+ '-' +month1 + '-' + '01' ,
            periods: [],         
            selectedPeriod: '',pdflogo:'',  
            summarizeRetainedEarnings: false, 
            hideZeroBalance: true, 
            openExportDialog: false, 
        };
        this.componentRef = React.createRef();
    }

    componentDidMount() {
        document.title = "Balance Report";
        let strname="Trial Balance Report";
		     if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
  this.apicall();	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
	 this.props.parentdasCallback(
            strname+"~"
        );	
       
    }

	PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=28')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
  this.apicall();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
    handleClickSearch = () => {
        this.apicall();
    }

    handlefromdate = (date) => {
       var month = "";
        var date1 = new Date(date);

        if ((date1.getMonth() + 1) < 10) {
            month = "0" + (date1.getMonth() + 1)
        } else { month = (date1.getMonth() + 1) }

        this.setState({
            fromdate: dayjs(date),
            fromdate1: date1.getFullYear() + '-' + month + '-' + date1.getDate(),
        })
    }
    todatehandler = (date) => {
        var month = "";
        var date1 = new Date(date);

        if ((date1.getMonth() + 1) < 10) {
            month = "0" + (date1.getMonth() + 1)
        } else { month = (date1.getMonth() + 1) }

        this.setState({
            todate: dayjs(date),
            todate1: date1.getFullYear() + '-' + month + '-' + date1.getDate(),
        })
    }
    
    handlePeriodChange = (event) => {
        this.setState({ selectedPeriod: event.target.value }, this.apicall); 
    }

    
    handleSummarizeRetainedEarningsChange = (event) => {
        this.setState({ summarizeRetainedEarnings: event.target.checked }, this.apicall);
    }

    handleHideZeroBalanceChange = (event) => {
        this.setState({ hideZeroBalance: event.target.checked }, this.apicall);
    }

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

    apicall() {
        const { fromdate1,todate1, selectedPeriod, summarizeRetainedEarnings, hideZeroBalance } = this.state;
        let url = localStorage.getItem("ISIurl") + 'ajaxreports.php?action=trialbalancereportgetall&cmp_id='+localStorage.getItem("ISIcmpid")+'&todate='+todate1+'&fromdate=' + fromdate1;

        if (selectedPeriod) {
            url += '&period=' + selectedPeriod;
        }

        url += '&summarizeRetainedEarnings=' + (summarizeRetainedEarnings ? '1' : '0');
        url += '&hideZeroBalance=' + (hideZeroBalance ? '1' : '0');

        axios.get(url)
            .then(resp => {
                let reportDataArray = [];
                if (Array.isArray(resp.data)) {
                    reportDataArray = resp.data;
                } else if (resp.data && Array.isArray(resp.data.data)) {
                    reportDataArray = resp.data.data;
                }

                const filteredReportData = hideZeroBalance
                    ? reportDataArray.filter(item => parseFloat(item.debit || 0) !== 0 || parseFloat(item.credit || 0) !== 0)
                    : reportDataArray;

                this.setState({
                    ReportData: filteredReportData,
                });
            })
        
    }
	 onchangedateHandler = (event) => {
        let selectedOption = event.target.value;
        const periodMap = {
            'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
            'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
            'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
            'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
            'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
            'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
            'This Financial Year': [dayjs().startOf('year').add(3, 'month'), dayjs().endOf('year').add(3, 'month')],
            'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('year').add(2, 'month')],
            'Custom': [dayjs(), dayjs().endOf('month')]
        };

        if (selectedOption === 'Custom') {
            this.setState({
                fromdate: periodMap['Custom'][0],
                todate: periodMap['Custom'][1],
                fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
                todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
                fromDateEnabled: true,
                toDateEnabled: true
            });
        } else {
            this.setState({
                fromdate: periodMap[selectedOption][0],
                todate: periodMap[selectedOption][1],
                fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
                todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
                fromDateEnabled: false,
                toDateEnabled: false
            });
        }
    };


	
handleClickOpen = () => {
  
      this.GetLogoForpdf();
  
  };

GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
} 
handleDownload = () => {
    const { ReportData } = this.state;
    const doc = new jsPDF();
	
    const imgWidth = 45;  
    const imgHeight = 20; 
    const imgX = (doc.internal.pageSize.width - imgWidth) / 2; 
    const imgY = 10;      
 if (this.state.pdflogo) {
	 const logoImage = this.state.pdflogo.startsWith('data:image')
      ? this.state.pdflogo
      : `data:image/jpeg;base64,${this.state.pdflogo}`;
  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
 }
 
    const title = 'Trial Balance Report';
    doc.setFontSize(16);

  
    const titleY = imgY + imgHeight + 8;

    doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
	const tableStartY = titleY + 10; 


    const headers = [
        ['Account Number', 'Account Name', 'Debit', 'Credit']
    ];

    const rows = ReportData.map(item => {
        return [
            item.le_code,
            item.le_ledgername,
            parseFloat(item.debit || 0).toFixed(2),
            parseFloat(item.credit || 0).toFixed(2),
        ];
    });

    doc.autoTable({
        head: headers,
        body: rows,
        startY: tableStartY, 
        theme: 'striped',
        didDrawPage: function (data) {
           
            var str = "Page " + doc.internal.getNumberOfPages();
            doc.setFontSize(10);
            doc.text(str, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });

        }
    });

    doc.save('Trialbalancereport.pdf');
    this.handleCloseExportDialog();
};

    render() {
        if (this.state.redirect === true) {
            return <Navigate to={this.state.pagename} />;
        }

        const sortedReportData = stableSort(this.state.ReportData, getSorting(this.state.order, this.state.orderBy));

        const totalDebit = sortedReportData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0);
        const totalCredit = sortedReportData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0);

        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul>
                        <li>
                            <p>From Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
									 disabled={!this.state.fromDateEnabled}
                                        value={dayjs(this.state.fromdate)}
                                        className="txtbox"
                                        onChange={this.handlefromdate}
                                        format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
						 <li>
                            <p>To Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        disabled={!this.state.toDateEnabled}
                                        value={dayjs(this.state.todate)}
                                        className="txtbox"
                                        onChange={this.todatehandler}
                                        format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>Period</p>
                            <p>
                                <Select
                                    native
                                    variant="outlined"
                                    className="txtbox"
                                    margin="normal"
                                    fullWidth
                                    onChange={this.onchangedateHandler}
                                    inputProps={{ tabIndex: '4' }}
                                >
                                    <option>This Month</option>
                                    <option>This Quarter</option>
                                    <option>This Year</option>
                                    <option>Last Month</option>
                                    <option>Last Quarter</option>
                                    <option>Last Year</option>
                                    <option>This Financial Year</option>
                                    <option>Last Financial Year</option>
                                    <option>Custom</option>
                                </Select>
                            </p>
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.summarizeRetainedEarnings}
                                        onChange={this.handleSummarizeRetainedEarningsChange}
                                        name="summarizeRetainedEarnings"
                                    />
                                }
                                label="Summarize retained earning values"
                            />
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.hideZeroBalance}
                                        onChange={this.handleHideZeroBalanceChange}
                                        name="hideZeroBalance"
                                    />
                                }
                                label="Hide Accounts with Zero Balance"
                            />
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                                    Calculate
                                </Button>
                                &nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
                            </p>
                        </li>
                    </ul>
                   
                </div>
 <div className="clear"></div>
                <div className="estimatebox">
                    <Paper>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table" id="balance-report-table" style={{paddings:'0px 4%'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Account Number</TableCell>
                                        <TableCell>Account Name</TableCell>
                                        <TableCell align="right">Debit</TableCell>
                                        <TableCell align="right">Credit</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {sortedReportData.length > 0 ? (
                                        sortedReportData.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.le_code}</TableCell>
                                                <TableCell>{item.le_ledgername}</TableCell>
                                                <TableCell align="right">
                                                    {parseFloat(item.debit || 0).toFixed(2) === '0.00' ? null : parseFloat(item.debit || 0).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {parseFloat(item.credit || 0).toFixed(2) === '0.00' ? null : parseFloat(item.credit || 0).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={4}>No Records</TableCell>
                                        </TableRow>
                                    )}

                                    {sortedReportData.length > 0 && (
                                        <TableRow>
                                            <TableCell colSpan={2} align="right"><b>Total:</b></TableCell>
                                            <TableCell align="right"><b>${totalDebit.toFixed(2)}</b></TableCell>
                                            <TableCell align="right"><b>${totalCredit.toFixed(2)}</b></TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </div>

                <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generated Detailed Trial Balance report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                        
										<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
						<ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="my-custom-excel-button" 
                    table="balance-report-table"
                    filename="Balance Report"
                    sheet="Balance Report"
                   
					
                /><img src={psdfimage} width={100} height={100} style={{ cursor: "pointer" }} onClick={this.handleClickOpen} alt="Download PDF" /></p>
                       
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>

                
            </React.Fragment>
        );
    }
}